if (!customElements.get('vbf-accordion')) {
  customElements.define(
    'vbf-accordion',
    class VbfAccordion extends HTMLElement {
      connectedCallback () {
        this.els = {
          trigger: this.querySelector('[ data-drawer-accordion-el="trigger"]'),
          body: this.querySelector('[ data-drawer-accordion-el="body"]'),
        }
        this.setupListeners()
      }

      setupListeners () {
        this.els.trigger.addEventListener('click', this.handleTriggerClick.bind(this))
      }

      handleTriggerClick () {
        this.style.setProperty(
          '--Max_Height',
          `${this.els.body.offsetHeight}px`,
        )

        const currentState = this.getAttribute('aria-expanded') === 'true'

        this.setAttribute('aria-expanded', !currentState)
        this.els.trigger.setAttribute('aria-expanded', !currentState)
      }

      scrollToAccordionBodyTop () {
        const drawer = this.closest('.drw-Drawer')
        const accordionBodyTop = this.els.body.getBoundingClientRect()
          .top
        const accordionBodyHeight = this.els.body.offsetHeight

        drawer.scrollTo({
          top: accordionBodyTop + accordionBodyHeight,
          behavior: 'smooth',
        })
      }
    },
  )
}
